export function getBrandFromHostname(hostname: string, search = ''): 'arnold' | 'pulser' {
  // Temporary design preview override; URL configuration callers omit search.
  if (new URLSearchParams(search).has('pulserDesign')) {
    return 'pulser';
  }

  const labels = hostname.trim().toLowerCase().replace(/\.+$/, '').split('.');
  return labels[labels.length - 2] === 'pulsersurvey' ? 'pulser' : 'arnold';
}
